import _ from 'lodash';
import React, { FC, useEffect, useState } from 'react';
import { Button, Form, Grid, Icon, Input, Modal, Step } from 'semantic-ui-react';
import { ButtonContainer, CodeContainer, FormContainer, InfoButtonContainer, InputLabel, LogoContainer, Logotipo, ResendCodeLink, ResendCodeText } from './styles';
import { EnvelopeSimple } from 'phosphor-react';
import Swal from 'sweetalert2';
import { encode } from 'base-64';
import { toast } from 'react-toastify';
import ReactCodeInput from 'react-verification-code-input';
import { useHistory } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { ForgetPasswordService } from '../../services/methods/ForgetPasswordService';


interface IForgetPasswordModal {
  forgetPasswordModalOpen: boolean;
  setForgetPasswordModalOpen(value: boolean): void;
}

enum BodyModal {
  options,
  input,
  code,
}

const ForgetPasswordModal: FC<IForgetPasswordModal> = ({ forgetPasswordModalOpen, setForgetPasswordModalOpen }) => {
  const forgetPasswordService: ForgetPasswordService = new ForgetPasswordService();


  const [email, setEmail] = useState('');
  const [bodyModal, setBodyModal] = useState<BodyModal>(BodyModal.options);
  const [counter, setCounter] = useState(0);
  const [activeButton, setActiveButton] = useState(false);
  const [sendCodeBy, setSendCodeBy] = useState<'email' | 'sms'>('email');
  const [validateCodeLoad, setValidateCodeLoad] = useState(false);
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [msgInfo, setMsgInfo] = useState('');

  const history = useHistory()

  async function handleAuthenticateEmail(sendBy: 'email' | 'sms') {
    if (email === '') {
      return Swal.fire({
        title: 'Atenção',
        text: 'O campo email é obrigatório.',
        icon: 'warning',
        confirmButtonText: 'Ok'
      })
    }
    const id = toast.loading("Por favor aguarde...")
    setCounter(0);
    try {
      setSendCodeBy(sendBy)
      const userBase64 = encode(email)
      const { data } = await forgetPasswordService.forgetService(userBase64, sendBy)
      const { status, msg, info } = data

      if (status === 'ok') {
        toast.update(id, { render: msg, type: "success", isLoading: false, autoClose: 5000, closeOnClick: true });
        if (info) {
          setMsgInfo(info)
        }
      } else {
        toast.update(id, { render: msg, type: "error", isLoading: false, autoClose: 5000, closeOnClick: true });
      }
      setBodyModal(BodyModal.code)
      setCounter(120)
    } catch (error) {
      toast.update(id, { render: "O servidor retornou um erro interno!", type: "error", isLoading: false, autoClose: 5000, closeOnClick: true });
    } finally {
      setValidateCodeLoad(false);

    }
  }

  async function handleValidateCode(code: string) {
    const id = toast.loading("Por favor aguarde...")
    try {
      const emailBase64 = encode(email)
      setValidateCodeLoad(true);

      const { data } = await forgetPasswordService.codeValidate(emailBase64, code);

      if (data.status === 'ok') {
        setToken(data.token)
        toast.update(id, { render: data.msg, type: "success", isLoading: false, autoClose: 5000, closeOnClick: true });
        setBodyModal(BodyModal.input)
      } else {
        toast.update(id, { render: data.errorMessage, type: "error", isLoading: false, autoClose: 5000, closeOnClick: true });
        return
      }
    } catch (error) {
      toast.update(id, { render: "O servidor retornou um erro interno!", type: "error", isLoading: false, autoClose: 5000, closeOnClick: true });
    } finally {
      setValidateCodeLoad(false);
    }
  }

  async function handleChangePassword() {
    if (newPassword === '') {
      return Swal.fire({
        title: 'Atenção',
        text: 'Preencha a senha.',
        icon: 'warning',
        confirmButtonText: 'Ok'
      })
    }

    if (newPassword !== confirmPassword) {
      setPasswordError('As senhas precisam ser iguais.');
      return;
    }
    setPasswordError('');
    const id = toast.loading("Por favor aguarde...")
    try {
      const objectParams = {
        token,
        password: encode(confirmPassword)
      }

      const { data } = await forgetPasswordService.newPassword(objectParams);

      if (data.status === 'ok') {
        setToken(data.token)
        toast.update(id, { render: data.msg, type: "success", isLoading: false, autoClose: 5000, closeOnClick: true });
        setBodyModal(BodyModal.options)
        setForgetPasswordModalOpen(false)
      } else {
        toast.update(id, { render: data.errorMessage, type: "error", isLoading: false, autoClose: 5000, closeOnClick: true });
      }
    } catch (error) {
      toast.update(id, { render: "O servidor retornou um erro interno!", type: "error", isLoading: false, autoClose: 5000, closeOnClick: true });
    }
  }


  useEffect(() => {
    let interval: NodeJS.Timeout
    if (counter > 0) {
      interval = setTimeout(() => {
        setCounter(counter - 1);
      }, 1000);
    } else {
      setActiveButton(false);
    }
    return () => clearInterval(interval);
  }, [counter]);

  function getBodyModal(): JSX.Element {

    if (bodyModal === BodyModal.options) {
      return (
        <Step
          active={forgetPasswordModalOpen}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            borderRadius: '2rem',
            border: 'none',
            width: '100%',
            zIndex: '3',
            background: '#fff'
          }}
        >
          <Step.Content
            style={{ width: '100%' }}
          >
            <Form>
              <FormContainer>
                <Form.Field style={{ width: '85%' }}>
                  <Step.Title
                    style={{ fontSize: '1.5rem', marginBottom: '0.5rem', color: '#54278b' }}
                  >
                    Informe seu e-mail
                  </Step.Title>

                  <Input
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </Form.Field>
                <span>Escolha a forma como deseja receber o código</span>
                <ButtonContainer>
                  <Button
                    circular
                    style={{ height: '11rem', width: '11rem', backgroundColor: '#54278b', color: 'white' }}
                    onClick={() => handleAuthenticateEmail('email')}
                    type='button'
                  >
                    <InfoButtonContainer>
                      <EnvelopeSimple size={40} color='white' />
                      <span>Enviar</span>
                    </InfoButtonContainer>
                  </Button>
                </ButtonContainer>
              </FormContainer>
            </Form>
          </Step.Content>
        </Step>
      )
    } else if (bodyModal === BodyModal.input) {
      return (
        <Step
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            borderRadius: '2rem',
            border: 'none',
            width: '100%',
            zIndex: '3',
            background: '#fff'
          }}
        >
          <Button
            style={{
              background: 'transparent',
              position: 'absolute',
              top: '1rem',
              left: 0,
              zIndex: 9999,
            }}
            onClick={() => setBodyModal(BodyModal.options)}
          >
            <Icon
              name='angle left'
              color='purple' // Semantic UI might not accept hex here for prop, but let's try style override if needed, or remove prop. Actually semantic ui 'purple' is close, but user wants #54278b.
              style={{ alignSelf: 'flex-start', color: '#54278b' }}
              size='big'
            />
          </Button>
          <Step.Content
            style={{ width: '100%' }}
          >
            <Form>
              <FormContainer>
                <Form.Field style={{ width: '100%' }}>
                  <label style={{ color: '#54278b', fontWeight: 'bold', fontSize: '1.2rem' }}>Nova Senha</label>
                  <Input
                    type='password'
                    placeholder='Digite sua nova senha'
                    style={{ marginTop: '0.5rem', marginBottom: '1rem' }}
                    value={newPassword}
                    onChange={e => setNewPassword(e.target.value)}
                  />

                  <label style={{ color: '#54278b', fontWeight: 'bold', fontSize: '1.2rem' }}>Confirmar senha</label>
                  <Input
                    type='password'
                    placeholder='Confirme sua nova senha'
                    style={{ marginTop: '0.5rem' }}
                    value={confirmPassword}
                    onChange={e => {
                      setConfirmPassword(e.target.value);
                      setPasswordError('');
                    }}
                  />
                  {passwordError && (
                    <span style={{ color: 'red', fontSize: '1.2rem', marginTop: '0.5rem', display: 'block' }}>
                      {passwordError}
                    </span>
                  )}
                </Form.Field>
                <Button
                  disabled={activeButton}
                  onClick={() => handleChangePassword()}
                  style={{ fontSize: '1.3rem', backgroundColor: '#54278b', color: 'white' }}
                >
                  Trocar a senha
                </Button>

              </FormContainer>
            </Form>
          </Step.Content>
        </Step>
      )
    } else if (bodyModal === BodyModal.code) {
      return (
        <Step
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '1rem',
            border: 'none',
            width: '100%'
          }}
        >
          <Button
            style={{
              background: 'transparent',
              position: 'absolute',
              top: '1rem',
              left: 0,
              zIndex: 9999,
            }}
            onClick={() => setBodyModal(BodyModal.options)}
          >
            <Icon
              name='angle left'
              style={{ alignSelf: 'flex-start', color: '#54278b' }}
              size='big'
            />
          </Button>
          <Step.Content>
            <Form>
              <FormContainer>
                {msgInfo.length !== 0 && <ResendCodeText>{msgInfo}</ResendCodeText>}
                <Step.Title
                  style={{ fontSize: '1.5rem', marginBottom: '0.5rem', color: '#54278b' }}
                >
                  Insira aqui o código enviado
                </Step.Title>
                <CodeContainer>
                  <ReactCodeInput
                    disabled={validateCodeLoad}
                    fields={6}
                    onComplete={(val) => handleValidateCode(val)}
                    fieldWidth={isMobile ? 38 : 50}
                    fieldHeight={isMobile ? 45 : 60}
                  />
                  {/* { codeColumnsInput } */}
                </CodeContainer>
              </FormContainer>
            </Form>
            {counter > 0 ? (
              <ResendCodeText>Reenviar o código disponível em <ResendCodeLink>{counter}</ResendCodeLink></ResendCodeText>
            ) : (
              <ResendCodeText>Não chegou o código? <ResendCodeLink onClick={() => handleAuthenticateEmail(sendCodeBy)}>clique aqui</ResendCodeLink> para reenviá-lo</ResendCodeText>
            )}
          </Step.Content>
        </Step>
      )
    } else {
      return <></>
    }
  }

  return (
    <Modal
      size='tiny'
      open={forgetPasswordModalOpen}
      closeIcon
      closeOnDimmerClick={false}
      onClose={() => {
        setForgetPasswordModalOpen(false)
        setBodyModal(BodyModal.options)
      }}
      onOpen={() => setForgetPasswordModalOpen(true)}
      style={{ borderRadius: '2rem' }}
    >
      <Step.Group
        stackable='tablet'
        style={{
          width: '100%',
          margin: '0'
        }}
      >
        {getBodyModal()}
      </Step.Group>
    </Modal>
  );
}

export default ForgetPasswordModal;
